export default __webpack_public_path__ + "static/media/logo_dark.ca4f6ad3.png";